<template>
    <v-container fluid>
        <!-- Data table for displaying exclusions -->
        <v-data-table locale="fr" :headers="headers" :search="search" no-data-text="Aucune sollicitation trouvée"
            :items="this.$store.getters['Auth/getSollicitation']" @click:row="goto" class="elevation-1 mb-5 px-5">
            <!-- Slot for custom row rendering -->
            <template v-slot:[`item.dateDemande`]="{ item }">
                {{ item.dateDemande | moment("DD MMMM YYYY") }}
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
    components: { DatePicker },
    data: () => ({
        headers: [
            { text: "Prenom", align: "start", sortable: false, value: "prenom" },
            { text: "Nom", sortable: false, value: "nom" },
            { text: "Email", sortable: false, value: "email" },
            { text: "Société", sortable: false, value: "societe" },
            { text: "Date de demande", sortable: false, value: "dateDemande" },
        ],
    }),
    created() {
        this.$store.dispatch("Auth/loadAllSollicitation");
        this.$store.dispatch("Auth/getData");
    },
    methods: {
        ...mapActions({
            loadAllSollicitation: "Auth/loadAllSollicitation",
            sendSollicitation: "Auth/addSollicitation"
        }),
        goto(value) {
            const { id } = value;
            this.$router.push({ name: "Regshow_sollicitation", params: { id: id } });
        },
    }
};
</script>

<style></style>
